export default {
  borderColor: 'brandTwo50',
  borderColorInverse: 'brandTwo10',
};
